export const municipalidadTypes = {
    MUNICIPALIDAD_RESET: '[municipalidad] RESET',
    MUNICIPALIDAD_GET_START: '[municipalidad] GET_START',
    MUNICIPALIDAD_GET_COMPLETE: '[municipalidad] GET_COMPLETE',
    MUNICIPALIDAD_GET_ERROR: '[municipalidad] GET_ERROR',
}